<p-drawer [(visible)]="showClientSidebar" [showCloseIcon]="false" (onHide)="CloseSidebar()" position="right" [dismissible]="false"
  [blockScroll]="true" styleClass="w-12 xl:w-11 no-header xl:overflow-hidden border-none p-0 lg:overflow-hidden client-info-sidebar">
  <!-- Row -->
  <ng-template #headless>
  <client-profile [clientId]="activeClientId" [interactionId]="interactionId" [activeTab]="activeTab"
    (closeClientSidebar)="closeClientSidebar($event)">
  </client-profile>
  </ng-template>
  <!-- Row -->
</p-drawer>